/**
 * Client-side mirrors of server limits. They exist to make a 400 rare, not to replace validation —
 * the server remains the authority and its rejection is still handled.
 */

/** 2 MiB, matching the contract exactly. Not 2 MB: the server means 2 * 1024 * 1024. */
export const MAX_PROOF_BYTES = 2 * 1024 * 1024;

export const ACCEPTED_PROOF_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;

/** The `accept` attribute value, derived so the two can never disagree. */
export const PROOF_ACCEPT_ATTRIBUTE = ACCEPTED_PROOF_MIME_TYPES.join(',');

export const PAYER_WALLET_MIN_LENGTH = 8;
export const PAYER_WALLET_MAX_LENGTH = 32;

export const UTR_MIN_LENGTH = 4;
export const UTR_MAX_LENGTH = 64;
